import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DirectivesModule } from '../directives/directives.module';
import { CheckboxModule } from '../checkbox/checkbox.module';
import { CheckableDropdownItemComponent } from './checkable-dropdown-item/checkable-dropdown-item.component';
import { DropdownItemComponent } from './dropdown-item/dropdown-item.component';
import { DropdownComponent } from './dropdown.component';
import { StaticDropdownComponent } from './static-dropdown/static-dropdown.component';
import { MultiSelectDropdownComponent } from './multiselect-dropdown/multiselect-dropdown.component';

@NgModule({
  declarations: [
    DropdownComponent,
    DropdownItemComponent,
    StaticDropdownComponent,
    CheckableDropdownItemComponent,
    MultiSelectDropdownComponent,
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    CheckboxModule,
    DirectivesModule,
  ],
  exports: [
    DropdownComponent,
    DropdownItemComponent,
    StaticDropdownComponent,
    CheckableDropdownItemComponent,
    MultiSelectDropdownComponent,
  ],
})
export class DropdownModule {}
